import React, { useEffect, useMemo } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { canBypassClosure } from "../../../utils/access";
import { useState } from "react";
import { Category, Menu, getAllCatagory } from "../../../api/category.api";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { State } from "../../../reducer";
import { getCafeStatus } from "../../../api/cafe.api";
import { User } from "../../../interfaces/user";

// Menu Card Skeleton Component
const MenuCardSkeleton: React.FC = () => {
  return (
    <div className="flex-wrap mx-5 my-8 justify-start">
      <div className="items-center flex flex-row justify-between h-[60px] w-full px-[8px] shadow rounded-lg bg-white animate-pulse">
        <div className="w-screen h-[60px] flex flex-col justify-center">
          <div className="h-[14px] bg-gray-200 rounded w-3/4 mb-1 mx-2"></div>
          <div className="h-[12px] bg-gray-200 rounded w-1/2 mx-2"></div>
        </div>
        <div className="w-6 h-6 bg-gray-200 rounded-full"></div>
      </div>
    </div>
  );
};

const MenuListBar: React.FC = () => {
  const user = useSelector((state: State) => state.user);
  const [categories, setCategories] = useState<Category[]>([]);
  const [selected, setSelected] = useState<number | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isTabLoading, setIsTabLoading] = useState(false);

  const handleTabChange = (categoryId: number) => {
    setIsTabLoading(true);
    setSelected(categoryId);
    // Simulate a brief loading time for tab change
    setTimeout(() => {
      setIsTabLoading(false);
    }, 300);
  };

  const menus = useMemo<Menu[]>(() => {
    if (selected === null) {
      return [];
    }

    const selectedCategory = categories.find((e) => e.id === selected);
    if (!selectedCategory) {
      return [];
    }

    const filteredMenus = selectedCategory.menus.filter(
      (item) => item.isAvailable === "available"
    );
    return filteredMenus;
  }, [categories, selected]);

  const storeRudux = (response: User) => {
    dispatch({
      type: "LOGIN",
      payload: response,
    });
  };

  useEffect(() => {
    getCafeStatus().then((result) => {
      const responsepost: User = {
        login: true,
        sub: "auth_google",
        id: user?.id,
        email: user?.email,
        name: user?.name,
        role: user?.role,
        isBarOpen: result?.isBarOpen,
        isCafeOpen: result?.isCafeOpen,
      };
      storeRudux(responsepost);
    });
    getAllCatagory().then((Categorie) => {
      const filtered = Categorie.filter(
        (item) => item.categoryFor === "bar" && item.isAvailable === "available"
      );
      setCategories(filtered);
      if (filtered.length > 0) {
        setSelected(filtered[0].id);
      }
      setIsLoading(false);
    });
    // Mount-only initial load (storeRudux is recreated every render).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectMenu = (
    menuID: number,
    menuName: string,
    menuDescription: string
  ) => {
    const sendIDOrder = {
      menu_id: menuID,
      menu_name: menuName,
      type: "",
      sweetness: 0,
      remark: "",
      tumblerImage: menuDescription,
    };
    dispatch({
      type: "SETMENU",
      payload: sendIDOrder,
    });
    if (user.role === "user") {
      navigate(`/form-bar/${menuName}/${menuID}/${menuDescription}`);
    } else if (user.role === "admin") {
      navigate(`/form-bar-admin/${menuName}/${menuID}/${menuDescription}`);
    }
  };
  const [showBanner, setShowBanner] = useState(false);
  const [showButton, setShowButton] = useState(true);

  useEffect(() => {
    if (!user?.isCafeOpen && !user?.isBarOpen && !canBypassClosure(user?.role))
      return navigate(
        user?.role === "admin" ? "/close-all-admin" : "/close-all"
      );
    const bannerShown = localStorage.getItem("bannerShown");
    if (bannerShown) {
      setShowBanner(false);
      setShowButton(true);
    } else {
      setShowBanner(true);
      setShowButton(false);
    }
    // Mount-only: closure redirect + banner state from the initial user snapshot.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseBanner = () => {
    setShowBanner(false);
    setShowButton(true);
    localStorage.setItem("bannerShown", "true");
  };

  const handleOpenBanner = () => {
    setShowButton(false);
    setShowBanner(true);
    localStorage.removeItem("bannerShown");
  };

  return (
    <>
      {showBanner ? (
        <div className="flex justify-between m-4 h-auto rounded bg-netural-N40">
          <div className="flex pl-2">
            <div className="pb-5 pt-3">
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 19.5H22L11 0.5L0 19.5ZM12 16.5H10V14.5H12V16.5ZM12 12.5H10V8.5H12V12.5Z"
                  fill="#292929"
                />
              </svg>
            </div>

            <span className="text-xs py-8 pl-[9px] font-nunito text-primary-onligth ">
              Relaxation might cause noise and disturb <br />
              other people, but should not affect the work.
              <br />
              <br />
              Fines for breaking glass per glass <br />
              Cocktail glass - 100 THB <br />
              Shot glass - 80 THB
              <br />
              <br />
              Transfer to this account <br />
              062-8480-095 Kbank <br />
              Pichamon P. <br />
            </span>
          </div>
          <div className="flex pb-5 pt-2 pr-2">
            <button
              data-dismiss-target="#sticky-banner"
              type="button"
              className="flex-shrink-0 inline-flex "
              onClick={handleCloseBanner}
            >
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.434425 0.434172C0.584447 0.284195 0.787893 0.199943 1.00002 0.199943C1.21216 0.199943 1.4156 0.284195 1.56562 0.434172L5.00002 3.86857L8.43443 0.434172C8.50822 0.357764 8.5965 0.296818 8.6941 0.254891C8.79171 0.212964 8.89668 0.190895 9.0029 0.189972C9.10913 0.189049 9.21447 0.20929 9.31279 0.249514C9.41111 0.289739 9.50043 0.349142 9.57554 0.424256C9.65065 0.49937 9.71006 0.588692 9.75028 0.687009C9.79051 0.785326 9.81075 0.89067 9.80983 0.996893C9.8089 1.10312 9.78683 1.20809 9.74491 1.3057C9.70298 1.4033 9.64203 1.49157 9.56563 1.56537L6.13122 4.99977L9.56563 8.43417C9.71135 8.58505 9.79199 8.78714 9.79016 8.99689C9.78834 9.20665 9.70421 9.4073 9.55588 9.55563C9.40755 9.70395 9.2069 9.78809 8.99715 9.78991C8.78739 9.79173 8.58531 9.7111 8.43443 9.56537L5.00002 6.13097L1.56562 9.56537C1.41474 9.7111 1.21266 9.79173 1.0029 9.78991C0.793146 9.78809 0.592496 9.70395 0.44417 9.55563C0.295843 9.4073 0.211708 9.20665 0.209885 8.99689C0.208062 8.78714 0.288698 8.58505 0.434425 8.43417L3.86883 4.99977L0.434425 1.56537C0.284448 1.41535 0.200195 1.2119 0.200195 0.999772C0.200195 0.787641 0.284448 0.584194 0.434425 0.434172Z"
                  fill="#292929"
                />
              </svg>
            </button>
          </div>
        </div>
      ) : null}
      <div className=" font-nunito font-semibold text-primary-onligth mx-5 my-[4px] flex  justify-between">
        <span className="text-center items-center my-auto">Menu </span>
        {showButton ? (
          <button
            onClick={handleOpenBanner}
            className="flex justify-between items-center gap-[5px] h-[32px] w-98px px-8 rounded-lg bg-warning-W300"
          >
            <div className="text-xs font-medium text-white">Please read</div>
            <svg
              width="12"
              height="10"
              viewBox="0 0 12 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.60753 9.96059H10.3925C11.2909 9.96059 11.8509 8.98643 11.4017 8.21059L7.0092 0.621426C6.56003 -0.154408 5.44003 -0.154408 4.99086 0.621426L0.598363 8.21059C0.149197 8.98643 0.709197 9.96059 1.60753 9.96059ZM6.00003 5.87726C5.6792 5.87726 5.4167 5.61476 5.4167 5.29393V4.12726C5.4167 3.80643 5.6792 3.54393 6.00003 3.54393C6.32086 3.54393 6.58336 3.80643 6.58336 4.12726V5.29393C6.58336 5.61476 6.32086 5.87726 6.00003 5.87726ZM6.58336 8.21059H5.4167V7.04393H6.58336V8.21059Z"
                fill="white"
              />
            </svg>
          </button>
        ) : null}
      </div>
      <div className="mx-3 text-14 font-nunito">
        <ul className="flex gap-0.5 m-2 overflow-x-auto overflow-y-auto">
          {categories.map((item) => (
            <button
              className={
                "tablinks py-4 px-[19px] w-full text-center whitespace-nowrap rounded-t-lg active focus:text-white focus:bg-[#F86903]" +
                (item.id === selected
                  ? " active text-white bg-[#F86903]"
                  : " bg-netural-N30 text-netural-N85")
              }
              onClick={() => handleTabChange(item.id)}
            >
              {item.name}
            </button>
          ))}
        </ul>
        <hr className="h-[1px] mx-2  bg-gray-200 border-0 dark:bg-gray-200"></hr>
      </div>

      <div className="tabcontent font-nunito">
        {isLoading || isTabLoading ? (
          <div className="w-screen h-fit">
            {Array.from({ length: 6 }).map((_, index) => (
              <MenuCardSkeleton key={index} />
            ))}
          </div>
        ) : (
          <div className=" w-screen h-screen overflow-y-auto">
            {menus.map((menu) => (
              <div key={menu.id} className="flex-wrap mx-5 my-8 justify-start">
                <button
                  className="items-center flex flex-row justify-between h-[60px] w-full  px-[8px] shadow rounded-lg text-gray-500 bg-white"
                  onClick={() => {
                    if (menu.isActive === "active") {
                      handleSelectMenu(menu.id, menu.name, menu.description);
                    } else {
                    }
                  }}
                  disabled={!menu.isActive}
                >
                  <div
                    className="w-screen h-[60px] flex flex-col justify-center"
                    style={{ wordBreak: "break-word" }}
                  >
                    <div
                      className={`${
                        menu.isActive === "active"
                          ? " text-primary-onligth"
                          : "text-gray-200"
                      } flex text-start text-14 px-2 font-semibold ${
                        menu.isActive === "active"
                          ? "cursor-pointer"
                          : "cursor-not-allowed"
                      }`}
                    >
                      {menu.name}
                    </div>
                    <div
                      className={`${
                        menu.isActive === "active"
                          ? "text-secondary-S700"
                          : "text-gray-200 "
                      } flex text-start text-12 px-2   ${
                        menu.isActive === "active"
                          ? "cursor-pointer"
                          : "cursor-not-allowed"
                      }`}
                    >
                      {menu.description ? menu.description : "-"}
                    </div>
                  </div>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill={menu.isActive === "active" ? "#633BCC" : "#A58DE1"}
                  >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V8c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
      <ToastContainer />
    </>
  );
};

export default MenuListBar;
